export default "__VITE_ASSET__DAYU$7v1__"